import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../Component/Baseurl";
import defaultlogo from "../Component/img/profile.webp";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

const EventSponsor = ({ sponsors, slug, type, selectedForms, eventUniqueId }) => {

  const navigate = useNavigate(); // Hook for navigation
    const [userId, setUserId] = useState(null); // State for storing userId
  
  useEffect(() => {
      const storedUserId = localStorage.getItem("visitor_id");
      setUserId(storedUserId); // Get userId from localStorage
    }, []);
  
    const handleButtonClick = (formfor) => {
      if (userId) {
        // If userId exists, navigate to the corresponding registration form
        const selectedForm = selectedForms.find((form) => form.formfor === formfor);
  
        console.log("id",selectedForm.id);
        console.log("selectedForms",selectedForms);
        if (selectedForm) {
          navigate(`/form/${selectedForm.id}/${eventUniqueId}`);
        }
      } else {
        // If no userId, navigate to login page
        navigate("/login");
      }
    };


  return (
    <div className="  bg-white p-1 mb-3">
      <div className="head-label py-1 text-start">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h2 className="h3clsss text-start mb-1 px-2">Sponsors</h2>
          </div>
          <div>
  {selectedForms.some((form) => form.formfor === "Sponsor") && (
    <button
      onClick={() => handleButtonClick("Sponsor")}
      className="viwmr btn btn-link"
    >
      Register as Sponsor
    </button>
  )}
</div>
        </div>

        <hr className="mb-2" />
        <div className="row g-1">
          {sponsors.length > 0 ? (
            sponsors.map((sponsor, index) => (
              <div key={index} className="col-lg-2 col-md-3 col-6">
                <div className="border rounded text-center ht100">
                  <div>
                    <img
                      src={
                        sponsor.profile_image
                          ? `${IMAGE_URL}sponsorFiles/${sponsor.profile_image}`
                          : defaultlogo
                      }
                      alt={`${sponsor.company} Logo`}
                      className="img-fluid my-1 evntimglogo"
                    />
                  </div>
                  <div className="nm1">
                    <strong>{sponsor.name}</strong>
                  </div>
                  <div className="nm1 text-muted">{sponsor.title}</div>
                </div>
              </div>
            ))
          ) : (
            <p>No sponsors available</p>
          )}

          <div className="col-lg-2 col-md-3 col-6 ">
            <div className="border rounded text-center ht100 d-flex justify-content-center align-items-center">
              <div className="nm1">
              {type === "conference" ? (
  <Link to={`/${slug}/sponsor`} target="_blank" className="viewmrbtn">
    View More
  </Link>
) : type === "workshop" ? (
  <Link to={`/workshop/${slug}/sponsor`} target="_blank" className="viewmrbtn">
    View More
  </Link>
) : 
type === "concert" ? (
  <Link to={`/concert/${slug}/sponsor`} target="_blank" className="viewmrbtn">
    View More
  </Link>
) : type === "sport" ? (
  <Link to={`/sport/${slug}/sponsor`} target="_blank" className="viewmrbtn">
    View More
  </Link>
) : (
  <Link to={`/${slug}/sponsors`} target="_blank" className="viewmrbtn">
    View More
  </Link>
)}

              </div>
              <div className="nm1 text-muted"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSponsor;
